import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { EngineTheme } from '@core/layout/services/theme.service';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-theme-picker',
    templateUrl: './theme-picker.component.html',
    styleUrls: ['./theme-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'themeMenu',
    imports: [
        MatMenu,
        MatMenuItem,
        MatIcon,
        TranslatePipe,
    ]
})
export class ThemePickerComponent {
  readonly menu = viewChild(MatMenu);
  readonly selectedTheme = input<EngineTheme>(undefined);
  EngineThemes = EngineTheme;

  readonly themeSelected = output<EngineTheme>();

  selectTheme(theme) {
    this.themeSelected.emit(theme);
  }
}
